import styled from 'styled-components'

export const CardPostoContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
  border-radius: 10px;
  border: 2px solid var(--border-color);
  display: flex;
  flex-direction: column;
  gap: 12px;

  div.CardPosto__cabecalho {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  div.CardPosto__cabecalho__icone {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--primary-color-light);
    color: var(--primary-color);
    font-size: 15px;
  }
  p.CardPosto__cabecalho__nome {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    color: var(--text-color);
    word-break: break-word;
  }
  span.CardPosto__cabecalho__legenda {
    font-size: 12px;
    font-weight: 500;
    color: var(--text-color-light);
  }

  div.CardPosto__infos {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 20px;
  }
  div.CardPosto__infos__item {
    display: flex;
    flex-direction: column;
    max-width: 100%;
  }
  p.CardPosto__infos__item__titulo {
    margin: 0;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-color-light);
  }
  span.CardPosto__infos__item__valor {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    color: var(--text-color);
    word-break: break-word;
  }
`
